export type Role = 'VIEWER' | 'EDITOR' | 'ADMIN' | 'OWNER';

export const ROLES: readonly Role[] = ['VIEWER', 'EDITOR', 'ADMIN', 'OWNER'];

export const ROLE_RANK: Readonly<Record<Role, number>> = {
  VIEWER: 0,
  EDITOR: 1,
  ADMIN: 2,
  OWNER: 3,
};

export type Action =
  | 'ledger:read'
  | 'ledger:update'
  | 'ledger:delete'
  | 'ledger:transfer'
  | 'transaction:create'
  | 'transaction:update'
  | 'transaction:delete'
  | 'category:manage'
  | 'category:quick-create'
  | 'budget:manage'
  | 'member:manage'
  | 'invite:manage';

export interface PolicyContext {
  readonly actorId: string;
  readonly resourceOwnerId?: string;
}

const MIN_ROLE: Readonly<Record<Action, Role>> = {
  'ledger:read': 'VIEWER',
  'transaction:create': 'EDITOR',
  'transaction:update': 'EDITOR',
  'transaction:delete': 'EDITOR',
  'category:manage': 'ADMIN',
  'category:quick-create': 'EDITOR',
  'budget:manage': 'ADMIN',
  'member:manage': 'ADMIN',
  'invite:manage': 'ADMIN',
  'ledger:update': 'ADMIN',
  'ledger:delete': 'OWNER',
  'ledger:transfer': 'OWNER',
};

const OWN_ONLY_FOR_EDITOR: ReadonlySet<Action> = new Set(['transaction:update', 'transaction:delete']);

export function atLeast(role: Role, minimum: Role): boolean {
  return ROLE_RANK[role] >= ROLE_RANK[minimum];
}

export function can(role: Role, action: Action, ctx?: PolicyContext): boolean {
  if (!atLeast(role, MIN_ROLE[action])) return false;
  if (role === 'EDITOR' && OWN_ONLY_FOR_EDITOR.has(action)) {
    return ctx !== undefined && ctx.resourceOwnerId !== undefined && ctx.actorId === ctx.resourceOwnerId;
  }
  return true;
}

export const ROLE_LABEL: Readonly<Record<Role, string>> = {
  VIEWER: 'Viewer',
  EDITOR: 'Editor',
  ADMIN: 'Admin',
  OWNER: 'Owner',
};
